import { down } from 'styled-breakpoints'
import styled from 'styled-components'

export const CampaignsHeading = styled.h2`
  color: #131717;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  margin: 0px 0px 16px 0px;
  ${down('md')} {
    font-size: 20px;
    font-weight: 600;
  }
`

export const CampaignsCard = styled.a`
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  border-radius: 12px;
  gap: 12px;
  margin: 0px auto 11px;
  overflow: hidden;

  ${down('md')} {
    // max-width: 253px;
    min-width: initial;
    margin-bottom: 0;
  }

  &:hover {
    img {
      transform: scale(1.08);
    }
  }
`
export const CampaignsText = styled.div`
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  z-index: 1;
  padding: 0px 8px;
`
export const CampaignsContainer = styled.div<{ isAllTabActive?: boolean }>`
  margin-top: 60px;
  margin-bottom: 60px;
  ${down('md')} {
    margin-bottom: 32px;

    /* "Tümü" tab'ı aktifken PNG görselinin dışarı taşması için */
    ${(props) =>
      props.isAllTabActive &&
      `
      [data-testid$='-tab-left-wrapper'] {
        margin-top: -20px;
        padding-top: 20px;
      }

      div[role='tablist'] {
        overflow: visible !important;
      }
    `}
  }

  /* Splide slider için padding-left - sadece ilk slide'a (sadece desktop) */
  .splide__slide:first-child {
    padding-left: 8px !important;
  }

  ${down('md')} {
    /* Mobilde padding-left'i kaldır */
    .splide__slide:first-child {
      padding-left: 0 !important;
    }
  }

  /* SnapCarousel için margin-left - SnapCarouselTrack içindeki SnapCarouselSlide'lere */
  [data-testid*='campaigns-carousel'] > div[style*='display: flex'] > div {
    margin-left: 8px !important;
  }

  [data-testid*='campaigns-carousel'] > div[style*='display: flex'] > div:first-child {
    margin-left: 0 !important;
  }
`

export const TabsButton = styled.div<{ active: boolean; isAllTab?: boolean }>`
  display: flex;
  padding: 10px 16px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  margin-bottom: 16px;
  background-color: transparent;
  border-radius: 200px;
  cursor: pointer;
  color: #131717;
  text-align: center;
  font-size: 14px;
  font-style: normal;
  font-weight: ${(props) => (props.active ? '600' : '400')};
  line-height: normal;
  white-space: nowrap;
  position: relative;
  z-index: 10;

  /* Tüm active tab'lar için gradient border */
  ${(props) =>
    props.active &&
    `
    border: 1px solid linear-gradient(135deg, #13882B 0%, #2DC44D 100%);
    border: 1px solid #2DC44D;
    color:  #1E8233;
    box-shadow: 0 0 4px 0 rgba(45, 196, 77, 1);

    
    &::before {
      position: absolute;
      inset: -1px;
      border-radius: 200px;
      border: 1px solid linear-gradient(135deg, #13882B 0%, #2DC44D 100%);
    }
  `}

  /* "Tümü" tab'ine özel - yeşil renk, box shadow ve PNG görseli */
  ${(props) =>
    props.isAllTab &&
    props.active &&
    `
    border: 1px solid #2DC44D;
    color:  #1E8233;
    
    box-shadow: 0 0 4px 0 rgba(45, 196, 77, 1);
  `}

  ${down('md')} {
    height: 39px;
    margin-right: 5px;
  }
`

export const SeeAllCampaign = styled.a<{ isTablet?: boolean }>`
  display: flex;
  padding: 7px 12px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 4px;
  border: 1px solid#D7DDDB;
  background: #fff;
  color: #131717;
  text-align: center;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 16px;
  height: 32px;
  transition: 0.3s all;
  &:hover {
    background-color: rgb(248, 250, 249);
    border-color: rgb(189, 197, 193);
  }
  ${down('md')} {
    font-size: 16px;
    margin-top: 16px;
    height: 50px;
  }

  ${({ isTablet }) =>
    isTablet &&
    `
    height: 44px;
    margin-top: 8px;
  `}
`

export const CampaignsHeadContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`

export const CampaignsImageContainer = styled.div`
  position: relative;
  height: 168px;
  width: 100%;
  overflow: hidden;
  border-radius: 12px;
  > img {
    border-radius: 12px;
    transition: transform 0.5s cubic-bezier(0.19, 1, 0.22, 1);
    object-fit: cover;
    /* background: linear-gradient(180deg, rgba(0, 0, 0, 0) 30.21%, rgba(0, 0, 0, 0.8) 87.24%), lightgray 50% / cover no-repeat; */
  }
`

export const CampaignCardWrapper = styled.div`
  ${down('md')} {
    padding-left: 4px !important;
  }
`

export const CampaignsSliderWrapper = styled.div`
  /* Sadece ilk slide'a margin-left (sadece desktop) */
  .splide__slide:first-child {
    padding-left: 4px !important;
  }

  ${down('md')} {
    /* Mobilde margin-left'i kaldır */
    .splide__slide:first-child {
      padding-left: 0 !important;
    }
  }
`

export const CampaignsCarouselWrapper = styled.div`
  /* SnapCarouselTrack içindeki SnapCarouselSlide'lere margin-left (sadece desktop) */
  > div > div > div {
    padding-left: 4px !important;
  }

  > div > div > div:first-child {
    padding-left: 0 !important;
  }

  ${down('md')} {
    /* Mobilde padding-left'i kaldır */
    > div > div > div {
      padding-left: 0 !important;
    }
  }
`
